import { render, staticRenderFns } from "./ThreePeopleIcon.vue?vue&type=template&id=6b537916"
import script from "./ThreePeopleIcon.vue?vue&type=script&lang=js"
export * from "./ThreePeopleIcon.vue?vue&type=script&lang=js"
import style0 from "./ThreePeopleIcon.vue?vue&type=style&index=0&id=6b537916&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports